module.exports = __webpack_public_path__ + "static/img/0004.1903d4e1.png";